import api from "@/services/api";

export const notificationService = {
  list: async () => (await api.get("/notifications")).data.data,
  markRead: async (id) => (await api.patch(`/notifications/${id}/read`)).data.data,
};
